import React, { useEffect } from 'react'
import {
	Authenticator,
	useAuthenticator
} from '@aws-amplify/ui-react'
import { Auth } from 'aws-amplify'
import SignIn from './SignIn'
import ConfirmSignIn from './ConfirmSignIn'
import RequireNewPassword from './RequireNewPassword'
import ForgotPassword from './ForgotPassword'
import { checkAccess } from './utils'
export { isAdmin } from './utils'

export default App => () => {
	const authProps = useAuthenticator()
	const { authStatus, route, user } = authProps
	const currentUserHasAccess = user ? checkAccess(user) : null

	useEffect(() => {
		if(authStatus === 'authenticated' && currentUserHasAccess === false) {
			Auth.signOut()
			authProps.signOut()
		}
	}, [authStatus, currentUserHasAccess])

	const renderAuthComponent = () => {
		if((authStatus === 'authenticated' || route === 'authenticated') && currentUserHasAccess === true) {
			return <App authData={user} signOut={authProps.signOut} />
		}
		if(route === 'signIn') {
			return <SignIn authProps={authProps} currentUserHasAccess={currentUserHasAccess} />
		}
		if(route === 'resetPassword' || route === 'confirmResetPassword') {
			return <ForgotPassword authProps={authProps}/>
		}
		if(route === 'forceNewPassword') {
			return <RequireNewPassword authProps={authProps}/>
		}
		if(route === 'confirmSignIn') {
			return <ConfirmSignIn authProps={authProps}/>
		}
	}

	// rendering the default Authenticator component is required for useAuthenticator hook to work
	return (<>
		<div style={{ display: 'none' }}><Authenticator/></div>
		{renderAuthComponent()}
	</>)
}
